import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DatastorePoolsModule,
  DatastoreUsersSelfModule,
} from '@freelancer/datastore/collections';
import { UiModule } from '@freelancer/ui';
import { LeaveCommunityConfirmationModalComponent } from './leave-community-confirmation-modal.component';

@NgModule({
  imports: [
    CommonModule,
    DatastorePoolsModule,
    DatastoreUsersSelfModule,
    UiModule,
  ],
  declarations: [LeaveCommunityConfirmationModalComponent],
})
export class LeaveCommunityConfirmationModalModule {}
